import { debounce } from 'lodash-es';
import React from 'react';
// Debounce timeout (ms).
const debounceTimeout = 100;
/**
 * Hook for scroll data.
 * @returns scrollTop: A number given the scroll position from the top. Defaults to 0.
 * @returns ref: A react ref that needs to get attached to the element.
 */
export const useScroll = () => {
    const scrollElementRef = React.useRef(null);
    const [scrollTop, setAbsoluteScrollPosition] = React.useState(0);
    // Debounce the scroll event for better web browser performance.
    const onScroll = React.useMemo(() => debounce(() => {
        setAbsoluteScrollPosition(scrollElementRef.current?.scrollTop ?? 0);
    }, debounceTimeout), []);
    React.useEffect(() => {
        const element = scrollElementRef.current;
        element?.addEventListener('scroll', onScroll);
        return () => {
            element?.removeEventListener('scroll', onScroll);
        };
    }, [onScroll]);
    return [scrollTop, scrollElementRef];
};
